<template lang="pug">
  .app-sublayer-header.mb-3
    slot
</template>

<script>
export default {
  name: 'app-sublayer-header'
}
</script>

<style lang="scss" scoped>
.app-sublayer-header {
  font-family: Roboto Slab;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 16px;

  color: #C4C4C4;
}
</style>